import { useState, useRef } from 'react';
import { Bell } from 'lucide-react';
import { useClickOutside } from '../../hooks/useClickOutside';

const mockNotifications = [
  { id: '1', title: 'New booking received', time: '2 min ago', read: false },
  { id: '2', title: 'Staff check-in alert', time: '15 min ago', read: false },
  { id: '3', title: 'Monthly report ready', time: '1 hr ago', read: true },
];

export default function NotificationBell() {
  const t = (k: string) => k.split('.').pop() ?? k;
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, () => setOpen(false));

  const unreadCount = mockNotifications.filter((n) => !n.read).length;

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="relative flex h-8 w-8 items-center justify-center rounded-lg text-content-muted hover:bg-surface-card-hover hover:text-content-primary transition-colors"
      >
        <Bell size={18} />
        {unreadCount > 0 && (
          <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-danger px-1 text-[10px] font-bold text-white">
            {unreadCount}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 z-50 w-72 rounded-lg border border-border bg-surface-card shadow-lg">
          <div className="border-b border-border px-4 py-3">
            <h3 className="text-sm font-semibold text-content-primary">{t('app.notifications')}</h3>
          </div>
          <div className="max-h-64 overflow-y-auto">
            {mockNotifications.map((n) => (
              <div
                key={n.id}
                className="flex items-start gap-3 border-b border-border px-4 py-3 last:border-0 hover:bg-surface-card-hover transition-colors cursor-pointer"
              >
                {!n.read && <span className="mt-1.5 h-2 w-2 rounded-full bg-primary flex-shrink-0" />}
                <div className={!n.read ? '' : 'ml-5'}>
                  <p className="text-sm text-content-primary">{n.title}</p>
                  <p className="text-xs text-content-muted mt-0.5">{n.time}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
